import BasicResource from '@/api/resource';

class PartnersResource extends BasicResource {

    constructor () {
        super('partners');
    }

    dict (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/dict/partners',
            params: { limit: -1, ...params },
        });
    }

    updateOwner (id, data) {
        return this.client.request({
            method: 'POST',
            path: `/upyield/v1/partners/${id}/save-owner`,
            data,
        });
    }

    clicktags (params) {
        let partnerId = params.partnerId;
        delete params.partnerId;

        return this.client.request({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/clicktags`,
            params,
        });
    }

    adAccounts (partnerId, params) {
        return this.client.request({
            method: 'GET',
            path: `/upyield/v1/partners/${ partnerId }/ad-accounts`,
            params,
        });
    }

    addAdAccount (data) {
        return this.client.request({
            method: 'POST',
            path: '/upyield/v1/ad-accounts',
            data,
        });
    }

    editAdAccount (adAccountId, data) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/ad-accounts/${adAccountId}`,
            data,
        });
    }

    adAccountPause (adAccountId) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/ad-accounts/${adAccountId}/pause`,
        });
    }

    adAccountUnpause (adAccountId) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/ad-accounts/${adAccountId}/unpause`,
        });
    }

    campaignPause (partnerId, extCampaignId) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/ext-campaigns/${extCampaignId}/pause`,
        });
    }

    campaignUnpause (partnerId, extCampaignId) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/ext-campaigns/${extCampaignId}/unpause`,
        });
    }

    removeCampaign (partnerId, extCampaignId) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/partners/${partnerId}/ext-campaigns/${extCampaignId}`,
        });
    }

    retrieveCampaign (partnerId, extCampaignId) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/ext-campaigns/${extCampaignId}/retrieve`,
        });
    }

    getExtCampaigns (partnerId, params) {
        return this.client.request({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/ext-campaigns`,
            params,
        });
    }

    getTrackingLinks (extCampaignId, params) {
        return this.client.request({
            method: 'GET',
            path: `/upyield/v1/ext-campaigns/${extCampaignId}/tracking-links`,
            params: {
                ...params,
                response_type: 'simple',
            },
        });
    }

    getCampaignDetails (partnerId, extCampaignId) {
        return this.client.request({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/ext-campaigns/${extCampaignId}`,
        });
    }

    removeTrackLink (extCampaignId, trackingLinkId) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/ext-campaigns/${extCampaignId}/tracking-links/${trackingLinkId}`,
        });
    }

    adAccountDict (params) {
        return this.client.request ({
            method: 'GET',
            path: '/upyield/v1/dict/partner-ad-accounts',
            params: params,
        });
    }

    campaignsDict (params) {
        return this.client.request ({
            method: 'GET',
            path: '/upyield/v1/dict/partner-ext-campaigns',
            params: params,
        });
    }

    syncCampaigns (adAccountId) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/ad-accounts/${adAccountId}/sync-campaigns`,
        });
    }

    updatePostbacks (id, data) {
        return this.client.request({
            method: 'POST',
            path: `/upyield/v1/partners/${id}/save-postbacks`,
            data,
        });
    }

    getApplicableOffers (partnerId, extCampaignId, params) {
        return this.client.request({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/offers?applicable_for_partner_ext_campaign=${extCampaignId}`,
            params: {
                ...params,
                response_type: 'simple',
            },
        });
    }


    addSelectedOfferCampaign (extCampaignId, data) {
        return this.client.request({
            method: 'POST',
            path: `/upyield/v1/ext-campaigns/${extCampaignId}/tracking-links`,
            data,
        });
    }

    updateClicktag (partnerId, clicktagId, data) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/clicktags/${clicktagId}`,
            data,
        });
    }

    addClicktag (partnerId, data) {
        return this.client.request({
            method: 'POST',
            path: `/upyield/v1/partners/${partnerId}/clicktags`,
            data,
        });
    }

    activate (partnerId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/${partnerId}/unpause`,
        });
    }

    pause (partnerId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/${partnerId}/pause`,
        });
    }

    bulkPause (payload) {
        return this.client.request ({
            method: 'put',
            path: '/upyield/v1/partners/bulk-pause',
            data: payload,
        });
    }

    bulkResume (payload) {
        return this.client.request ({
            method: 'put',
            path: '/upyield/v1/partners/bulk-unpause',
            data: payload,
        });
    }

    activateLink (linkId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/link/${linkId}/unpause`,
        });
    }

    pauseLink (linkId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/link/${linkId}/pause`,
        });
    }

    pauseLinks (partnerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/${partnerId}/link/bulk-pause`,
            data: payload,
        });
    }

    resumeLinks (partnerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/${partnerId}/link/bulk-unpause`,
            data: payload,
        });
    }

    disableLinksFraudProtection (partnerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/${partnerId}/link/bulk-fraud-protection-disable`,
            data: payload,
        });
    }

    enableLinksFraudProtection (partnerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/${partnerId}/link/bulk-fraud-protection-enable`,
            data: payload,
        });
    }

    setLinksTracking (payload) {
        return this.client.request ({
            method: 'put',
            path: '/upyield/v1/partners/link/bulk-tracking-update',
            data: payload,
        });
    }

    deleteClicktag (params) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/partners/${params.partnerId}/clicktags/${params.clicktagId}`,
        });
    }

    offerRunningPartners (offerId, params) {
        params = {
            ...params,
            running: [ offerId ],
        };

        return this.list(params);
    }

    offerNotRunningPartners (offerId, params) {
        params = {
            ...params,
            not_running: [ offerId ],
        };

        return this.list(params);
    }

    offersList (partnerId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/partners/${partnerId}/offers`,
            params: params,
        });
    }

    payoutsHistoryList (partnerId, offerId) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/partners/${partnerId}/offers/${offerId}/payouts`,
        });
    }

    pixelsList (linkId) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/partners/link/${linkId}/pixels`,
        });
    }

    changeFraudProtection (partnerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/link/${partnerId}/fraud-protection`,
            data: payload,
        });
    }

    changeTracking (partnerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/link/${partnerId}/tracking`,
            data: payload,
        });
    }

    payoutsForLink (linkId, params) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/partners/link/${linkId}/payouts`,
            params,
        });
    }

    capsForLink (linkId, params) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1//partners/link/${linkId}/history?entity_type=TrackingLinkCap`,
            params,
        });
    }

    addPayoutForLink (linkId, payload) {
        delete payload.event_type;

        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/link/${linkId}/budget`,
            data: [ payload ],
        });
    }

    removePayoutForLink (linkId, eventTypeId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/link/${linkId}/budget`,
            data: [ {
                event_type_id: eventTypeId,
                payout: null,
                revenue: null,
            } ],
        });
    }

    addCapForLink (linkId, payload) {
        delete payload.event_type;

        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/link/${linkId}/caps`,
            data: [ payload ],
        });
    }

    removeCapForLink (linkId, capId) {
        if (typeof linkId === 'undefined' || typeof capId === 'undefined') return;

        return this.client.request ({
            method: 'delete',
            path: `/upyield/v1/partners/link/${linkId}/caps/${capId}`,
        });
    }

    changeCurrency (partnerId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/partners/${partnerId}/currency`,
            data: payload,
        });
    }

    users (partnerId, params) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/users`,
            params,
        });
    }

    addUser (partnerId, payload) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/partners/${partnerId}/users`,
            data: payload,
        });
    }

    modifyUser (partnerId, payload, userId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/users/${userId}`,
            data: payload,
        });
    }

    reportDownload (params) {
        return this.client.download({
            method: 'get',
            responseType: 'blob',
            path: '/upyield/v1/partners/download',
            params,
        });
    }

    getTrackingParams (params) {
        return this.client.request ({
            method: 'GET',
            path: '/upyield/v1/dict/publisher-tracking-params',
            params,
        });
    }

    getClicktagParams (params) {
        return this.client.request ({
            method: 'GET',
            path: '/upyield/v1/dict/publisher-tracking-params',
            params: { available_for_clicktag: 1, ...params },
        });
    }

    setBlacklistedParams (partnerId, data) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/query-filtering`,
            data,
        });
    }

    setBlacklistedTspParams ({ tspId, data }) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/link/${tspId}/query-filtering`,
            data,
        });
    }

    enableExternalIntegration (partnerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/external-integration-enable`,
        });
    }

    disableExternalIntegration (partnerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/external-integration-disable`,
        });
    }

    getPartnerTokenList (partnerId) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/pat`,
        });
    }

    generatePartnerToken (partnerId) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/partners/${partnerId}/pat`,
        });
    }

    revokePartnerToken (partnerId) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/partners/${partnerId}/pat`,
        });
    }

    paymentsList (partnerId, params) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/payment-requests`,
            params,
        });
    }

    getPayment (partnerId, id) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/payment-requests/${id}`,
        });
    }

    creditNotes (partnerId, params) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/credit-notes`,
            params,
        });
    }

    getCreditNote (partnerId, id) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/credit-notes/${id}`,
        });
    }

    generateCreditNote (partnerId, data) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/credit-notes/generate`,
            data,
        });
    }

    enableBilling (partnerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/enable-billing`,
        });
    }

    customParameters (partnerId, params = {}) {
        return this.client.request({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/tracking-parameters`,
            params,
        });
    }

    addCustomParameter (partnerId, data) {
        return this.client.request({
            method: 'POST',
            path: `/upyield/v1/partners/${partnerId}/tracking-parameters`,
            data,
        });
    }

    updateCustomParameter (partnerId, parameterId, data) {
        return this.client.request({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/tracking-parameters/${parameterId}`,
            data,
        });
    }

    deleteCustomParameter (partnerId, parameterId) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/partners/${partnerId}/tracking-parameters/${parameterId}`,
        });
    }

    getCookieValueOptions (partnerId) {
        return this.client.request ({
            method: 'GET',
            path: '/upyield/v1/dict/partner-cookies-mapping',
            params: { partner_id: partnerId, limit: -1 },
        });
    }

    enableCookiesProcessing (partnerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/cookies-processing-enable`,
        });
    }

    cookiesMappings (partnerId, params) {
        return this.client.request ({
            method: 'GET',
            path: `/upyield/v1/partners/${partnerId}/cookies-mappings`,
            params,
        });
    }

    addCookiesMapping (partnerId, data) {
        return this.client.request ({
            method: 'POST',
            path: `/upyield/v1/partners/${partnerId}/cookies-mappings`,
            data,
        });
    }

    updateCookiesMapping (partnerId, mappingId, data) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/cookies-mappings/${mappingId}`,
            data,
        });
    }

    restoreCookiesMapping (partnerId, mappingId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/cookies-mappings/${mappingId}/restore`,
        });
    }

    deleteCookiesMapping (partnerId, mappingId) {
        return this.client.request ({
            method: 'DELETE',
            path: `/upyield/v1/partners/${partnerId}/cookies-mappings/${mappingId}`,
        });
    }

    disableCookiesProcessing (partnerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/cookies-processing-disable`,
        });
    }

    enableSkadSigning (partnerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/skad-signing-enable`,
        });
    }

    disableSkadSigning (partnerId) {
        return this.client.request ({
            method: 'PUT',
            path: `/upyield/v1/partners/${partnerId}/skad-signing-disable`,
        });
    }

    updateOptimizations (partnerId, data) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${partnerId}/optimizations`,
            data,
        });
    }

    enableOptimizations (partnerId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${partnerId}/optimizations-enable`,
        });
    }

    disableOptimizations (partnerId) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${partnerId}/optimizations-disable`,
        });
    }

    trackingLinksReportDownload (partnerId) {
        return this.client.download({
            method: 'get',
            responseType: 'blob',
            path: `/upyield/v1/${this.resourceName}/${partnerId}/tracking-links/download`,
        });
    }
}

export default new PartnersResource;
